import { darken } from "@mui/material";
import { COLORS } from "../../../constants";
import { HALO } from "../../../constants/colors";
export var baseButtonStylesFn = function (_a) {
    var loading = _a.loading;
    return ({
        px: 9,
        py: 3.5,
        height: "auto",
        borderRadius: "100px",
        textTransform: "none",
        fontWeight: 600,
        fontSize: 14,
        lineHeight: "20px",
        letterSpacing: "0px",
        ":active": {
            boxShadow: "none",
        },
        "&.MuiButton-sizeMini": {
            py: 2,
        },
        "&.MuiButton-sizeSmall": {
            py: 2.5,
        },
        ".MuiButton-icon": {
            width: "18px",
            height: "18px",
        },
        ".MuiButton-deleteIcon": {
            height: "18px",
            width: "18px",
            marginRight: "8px",
            color: "rgba(0, 0, 0, 0.5)",
        },
        "&.Mui-disabled.Mui-disabled": {
            background: loading ? undefined : COLORS.LIGHT_GREY,
            opacity: 1,
            color: COLORS.P_DISABLED,
            ".MuiButton-startIcon": {
                color: COLORS.P_DISABLED,
            },
            ".MuiButton-deleteIcon": {
                color: COLORS.P_OUTLINE,
            },
        },
        ".MuiCircularProgress-root": {
            color: "primary.contrastText",
        },
        /// PRIMARY
        "&.MuiButton-primary": {
            color: "primary.contrastText",
            bgcolor: "primary.main",
            ".MuiButton-startIcon": {
                color: "primary.contrastText",
            },
            "&:hover": {
                bgcolor: "primary.dark",
            },
            "& > .MuiTouchRipple-root": {
                color: darken(COLORS.SAY_COBALT_PRESSED, 0.15),
            },
            "&:focus-visible": {
                bgcolor: "primary.main",
                boxShadow: HALO,
            },
        },
        /// SECONDARY
        "&.MuiButton-secondary": {
            color: "secondary.contrastText",
            bgcolor: "secondary.main",
            ".MuiButton-startIcon": {
                color: "secondary.contrastText",
            },
            "&:hover": {
                bgcolor: "secondary.dark",
            },
            "& > .MuiTouchRipple-root": {
                color: darken(COLORS.SECONDARY_PRESSED, 0.15),
            },
            "&:focus-visible": {
                bgcolor: COLORS.WHITE,
                boxShadow: HALO,
            },
            ".MuiCircularProgress-root": {
                color: "secondary.contrastText",
            },
        },
        /// TEXT
        "&.MuiButton-text": {
            color: "primary.main",
            bgcolor: "transparent",
            px: 3.5,
            ".MuiButton-startIcon": {
                color: "primary.main",
            },
            "&:hover": {
                color: "primary.dark",
            },
            "& > .MuiTouchRipple-root": {
                color: "transparent",
            },
            "&:active": {
                color: COLORS.SAY_COBALT_PRESSED,
            },
            "&:focus-visible": {
                boxShadow: HALO,
            },
            "&.Mui-disabled.Mui-disabled": {
                background: "transparent",
            },
            ".MuiCircularProgress-root": {
                color: "primary.main",
            },
        },
        /// TEXT
        "&.MuiButton-textDark": {
            color: "primary.contrastText",
            bgcolor: "transparent",
            px: 3.5,
            ".MuiButton-startIcon": {
                color: "primary.contrastText",
            },
            "&:hover": {
                color: COLORS.S_MED_EMPHASIS,
            },
            "& > .MuiTouchRipple-root": {
                color: "transparent",
            },
            "&:active": {
                color: COLORS.S_MED_LOW_EMPHASIS,
            },
            "&:focus-visible": {
                boxShadow: HALO,
            },
            "&.Mui-disabled.Mui-disabled": {
                background: "transparent",
            },
            ".MuiCircularProgress-root": {
                color: "primary.contrastText",
            },
        },
        /// TEXT_SECONDARY
        "&.MuiButton-textSecondary": {
            color: COLORS.P_HIGH_EMPHASIS,
            px: 3.5,
            bgcolor: "transparent",
            ".MuiButton-startIcon": {
                color: COLORS.P_HIGH_EMPHASIS,
            },
            "&:hover": {
                color: COLORS.P_MED_EMPHASIS,
            },
            "& > .MuiTouchRipple-root": {
                color: "transparent",
            },
            "&:active": {
                color: COLORS.P_MED_LOW_EMPHASIS,
            },
            "&:focus-visible": {
                boxShadow: HALO,
            },
            "&.Mui-disabled.Mui-disabled": {
                background: "transparent",
            },
            ".MuiCircularProgress-root": {
                color: COLORS.P_HIGH_EMPHASIS,
            },
        },
        /// WARNING
        "&.MuiButton-warning": {
            color: "error.contrastText",
            bgcolor: "error.main",
            ".MuiButton-startIcon": {
                color: "error.contrastText",
            },
            "&:hover": {
                bgcolor: "error.dark",
            },
            "& > .MuiTouchRipple-root": {
                color: darken(COLORS.ERROR_PRESSED, 0.15),
            },
            "&:focus-visible": {
                bgcolor: "error.main",
                boxShadow: HALO,
            },
        },
        /// WARNING_SECONDARY
        "&.MuiButton-warningSecondary": {
            color: "error.main",
            bgcolor: "secondary.main",
            ".MuiButton-startIcon": {
                color: "error.main",
            },
            "&:hover": {
                bgcolor: "secondary.dark",
            },
            "& > .MuiTouchRipple-root": {
                color: darken(COLORS.SECONDARY_PRESSED, 0.15),
            },
            "&:focus-visible": {
                bgcolor: COLORS.WHITE,
                boxShadow: HALO,
            },
            ".MuiCircularProgress-root": {
                color: "error.main",
            },
        },
    });
};
